import {
  Box,
  Button,
  Card,
  InlineStack,
  OptionList,
  Popover,
  Tabs,
} from "@shopify/polaris";
import React, { useCallback, useEffect, useState } from "react";
import { PlayCircleIcon } from "@shopify/polaris-icons";
import "./index.css";
import SourcingFilterBox from "./component/SourcingFilterBox";
import SourcingTableBox from "./component/SourcingTableBox";
import SourcingRequestModal from "./component/SourcingRequestModal";
import EnoughQuotaModal from "./component/EnoughQuotaModal";
import EnoughPointsModal from "./component/EnoughPointsModal";
import NoviceSourcingModal from "../../../../components/NoviceGuidance/NoviceSourcingModal";
import CommonTableFilterSkeleton from "./component/CommonTableFilterSkeleton"
import MobileTableBox from "./component/MobileTableBox";
import { reqGetSourcingListData, reqGoogleAnalytics } from "../../../../api";
import { useSelector } from "react-redux";
import { store } from "../../../../store";
import { changeSourcingData } from "../../../../slice";
import { withRouter } from "react-router-dom/cjs/react-router-dom";
import SearchLoading from "../../../../components/SearchLoading";
const SourcingRequestBox = ({
  planData,
  setPlanData,
  userPoints,
  setUserPoints,
  setPremiumData,
  handleMageUpgrade,
  subList,
  toastFun,
  planShow,
  handleModalCallback
}) => {
  const shopify = window.shopify;
  const [active, setActive] = useState(false); // 是否打开source类型选择
  const [selectedType, setSelectedType] = useState(["My quote"]); // 默认常规找货
  const [isPopupOpen, setIsPopupOpen] = useState(false); // 是否打开popup 创建找货
  const [loading,setLoading] = useState(false);// 页面状态加载
  const [noviceModal,setNoviceModal] = useState(false);
  const [initPage,setInitPage] = useState(true)// 初始化骨架屏
  const openPopup = () => {
    setIsPopupOpen(true);
  };

  const closePopup = () => {// 关闭弹窗
    setIsPopupOpen(false);
  };

  const toggleActive = useCallback(() => setActive((active) => !active), []); // 打开source类型选择

  const [tabs, setTabs] = useState([
    {
      id: "all-customers-1",
      content: "All(0)",
      accessibilityLabel: "All customers",
      panelID: "all-customers-content-1",
    },
    {
      id: "accepts-marketing-1",
      content: "Pending(0)",
      panelID: "accepts-marketing-content-1",
    },
    {
      id: "repeat-customers-1",
      content: "Failed(0)",
      panelID: "repeat-customers-content-1",
    },
    {
      id: "prospects-1",
      content: "Success(0)",
      panelID: "prospects-content-1",
    },
  ]);
  // 请求参数
  const [requestParams, setRequestParams] = useState({
    page: 1,
    size: 20,
    search_from:1,
    q:'',
    sourcing_status:[],
    platform:1
  });

  // 次数不足
  const [sourcingLimitModal,setSourcingLimitModal] = useState(false)

  // 达到上限
  const [enoughPoint,setEnoughPoint] = useState(false);
  // 列表数据
  const [listData, setListData] = useState({
    list:[]
  });

 
  // 获取列表数据
  const getListData = async(data) => {
    try {
      let params = {...requestParams,...data}
      setRequestParams((prevValue)=>({
        ...prevValue,
        ...params
      }))
      if (params.sourcing_status.length === 0) {
        params.sourcing_status = 'All'
      }
      if (data) {
        setLoading(true)
      }
      if (params.sourcing_status.length !== 0 && typeof params.sourcing_status === "object") {
        params.sourcing_status = params.sourcing_status[0]
      }
      let res = await reqGetSourcingListData(params)
      // res = deData
      if (res.code === '200') {
        let pageData = res.data;
           setUserPoints((prevValue)=>({// 创建成功重置积分使用规则
          ...prevValue,
          userPointsRedeem:{
            open:false,
            id:0,
            isDetail:false,
            is_new:0,
            isPoints:false
          }
        }))
        setTabs([
          {
            id: "all-customers-1",
            content: "All("+pageData.summary.All+")",
            accessibilityLabel: "All customers",
            panelID: "all-customers-content-1",
          },
          {
            id: "accepts-marketing-1",
            content: "Pending("+pageData.summary.Pending+")",
            panelID: "accepts-marketing-content-1",
          },
          {
            id: "repeat-customers-1",
            content: "Failed("+pageData.summary.Failed+")",
            panelID: "repeat-customers-content-1",
          },
          {
            id: "prospects-1",
            content: "Success("+pageData.summary.Success+")",
            panelID: "prospects-content-1",
          },
        ])
        let list = pageData.list.map((item, index) => {
          item.checked = 0;
          item.failed_active = 0
          return item;
        });
        setListData({...pageData,list});
      }else {
        setListData({
          list:[],
          summary:{
            All:0,
            Pending:0,
            Failed:0,
            Success:0
          }
        })
      }
      setInitPage(false)
      setLoading(false)
    } catch (error) {
      
    }
  };
  const plan_level = useSelector(
    (state) => state.languageReducer.subScriptData
  );
   // 打开sourcing弹窗，详情弹窗
  const handleSourcingModal = () => {
    //Sourcing页面sourcing按钮点击gtag
    reqGoogleAnalytics('click', 'sourcing_sourcing_click');
    // 查看sourcing详情
    
    try {
    
    if (planData.use_sourcing >= planData.add_sourcing && planData.sourcingLimit >= planData.sourcingDay) {
      if ((plan_level.bill_level === 5 || plan_level.level === 5) && userPoints.userPointsData.available_points < 200) {
        setEnoughPoint(true)
        return
      }else {
        setSourcingLimitModal(true)
      }
      
    }else {
      if (shopify) {
        window.history.replaceState({}, '', '/admin/product_selection/sourcing-detail')
        handleModalCallback('/admin/product_selection/sourcing-detail','Sourcing_Detail_Modal',{isPoints:false})
        store.dispatch(changeSourcingData({sourcing:{
          show:true,
        }}));
      }else {
        openPopup()
      }
    }
  } catch (error) {
      
  }
  }

  
 

  const handleSubmit = (val) => {
    if (val) {
        if (val === 5) {
            setPremiumData((prevValue) => ({
                ...prevValue,
                open: true,
              }));
            setSourcingLimitModal(false)
        }
        if (val === 6) {
          setUserPoints((prevValue)=>({
            ...prevValue,
            userPointsRedeem:{
              ...prevValue.userPointsRedeem,
              isPoints:true
            }
          }))
          setSourcingLimitModal(false)
          if (shopify) {
            window.history.replaceState({}, '', '/admin/product_selection/sourcing-detail')
            handleModalCallback('/admin/product_selection/sourcing-detail','Sourcing_Detail_Modal',{isPoints:true})
            store.dispatch(changeSourcingData({sourcing:{
              show:true,
            }}));
            
          }else {
            openPopup()
          }
        }
        if (val <5) {
          handleMageUpgrade(val)
        }
    }
  };



  useEffect(() => {
    let isMount = false;
    if (!isMount) {
      getListData();
    }
    return () => {
      isMount = true;
    };
    // eslint-disable-next-line
  }, []);

  //   tab选择
  const [selected, setSelected] = useState(0);
  //   tab切换
  const handleTabChange = (selectedTabIndex) => {
      setSelected(selectedTabIndex);
      let params = {page: 1,
        size: 20,
        search_from:1,
        q:'',
        sourcing_status:[]
      }
      switch (selectedTabIndex) {
        case 0:
          getListData(params)
          break;
        case 1:
          getListData({...params,sourcing_status:['Pending']})
          break;
        case 2:
          getListData({...params,sourcing_status:['Failed']})
          break;
        case 3:
          getListData({...params,sourcing_status:['Success']})
          break;
      
        default:
          getListData({...params,sourcing_status:[]})
          break;
      }
    }
  // 切换按钮
  const activator = (
    <Button variant="tertiary" onClick={toggleActive} disclosure>
      <strong>{selectedType}</strong>
    </Button>
  );
  const widthPage = useScreenWidth();
  
  return (
    <div  style={{position:'relative'}}>
    {initPage && <CommonTableFilterSkeleton /> }
    <Box className="sourcing_request_box" style={{opacity: initPage ? 0 : 1}}>
      <Box className="sourcing_request_head">
        <InlineStack gap={200} blockAlign="center" align="space-between">
          <Box className="sourcing_request_head_title">
            <InlineStack wrap={false} blockAlign="center">
              <strong>Sourcing:</strong>
              <Popover
                active={active}
                activator={activator}
                autofocusTarget="first-node"
                onClose={toggleActive}
              >
                <OptionList
                  onChange={(value)=>{
                    if (value[0] === "Shopify order") {
                      getListData({
                        page: 1,
                        size: 20,
                        search_from:1,
                        q:'',
                        sourcing_status:[],
                        platform:2})
                    }else {
                      getListData({page: 1,
                        size: 20,
                        search_from:1,
                        q:'',
                        sourcing_status:[],
                        platform:1})
                    }
                    setSelected(0)
                    setSelectedType(value)
                    
                  }}
                  options={[
                    { value: "My quote", label: "My quote" },
                    { value: "Shopify order", label: "Shopify order" },
                  ]}
                  selected={selectedType}
                />
              </Popover>
            </InlineStack>
          </Box>
          {selectedType[0] === "My quote" ? (
            <Box className="sourcing_request_head_button">
              <InlineStack blockAlign="center" gap={200}>
                <Button icon={PlayCircleIcon} onClick={()=>setNoviceModal(true)}>Watch Tutorial</Button>
                <Button variant="primary"  onClick={() => handleSourcingModal()}>
                  Sourcing Request ({((planData.sourcingLimit > planData.sourcingDay) ? planData.sourcingDay : planData.sourcingLimit) + planData.use_sourcing}/{planData.sourcingDay+planData.add_sourcing})
                </Button>
              </InlineStack>
            </Box>
          ) : (
            ""
          )}
        </InlineStack>
      </Box>
      <Box className="sourcing_request_body">
        <Card padding={0}>
          <Tabs
            tabs={tabs}
            selected={selected}
            onSelect={handleTabChange}
          ></Tabs>
          <Box>
            <SourcingFilterBox selectedType={selectedType} selected={selected} requestParams={requestParams} setRequestParams={setRequestParams} getListData={getListData}/>
          </Box>
          {widthPage >= 420 ? <Box>
            <SourcingTableBox selectedType={selectedType} toastFun={toastFun} listData={listData} setListData={setListData} loading={loading} requestParams={requestParams} setRequestParams={setRequestParams} getListData={getListData}/>
          </Box> : <Box>
            <MobileTableBox selectedType={selectedType} toastFun={toastFun} listData={listData} setListData={setListData} loading={loading} requestParams={requestParams} setRequestParams={setRequestParams} getListData={getListData}/>
          </Box>}
        </Card>
        {/* 创建source */}
        <SourcingRequestModal
          isOpen={isPopupOpen}
          onClose={closePopup}
          show={true}
          updateCallBackFun={() => {
            setPlanData((prevValue) => {
              const { use_sourcing, add_sourcing, sourcingLimit } = prevValue;
              const usageToAdd = 1;
              const remainingQuota = add_sourcing - use_sourcing;
            
              let updatedUseSourcing = use_sourcing;
              let updatedSourcingLimit = sourcingLimit;
            
              if (add_sourcing > 0 && use_sourcing >= add_sourcing) {
                // 加量包已消耗完，全部计入sourcingLimit
                updatedSourcingLimit += usageToAdd;
              } else if (remainingQuota >= usageToAdd) {
                // 加量包足够使用
                updatedUseSourcing += usageToAdd;
              }
            
              return {
                ...prevValue,
                use_sourcing: updatedUseSourcing,
                sourcingLimit: updatedSourcingLimit,
              };
            });
            if (userPoints.userPointsRedeem.isPoints) {
              setUserPoints((prevValue)=>({
                ...prevValue,
                userPointsData:{
                  ...prevValue.userPointsData,
                  available_points:Number(prevValue.userPointsData.available_points) - 200
                }
              }))
            }
            getListData()
          }}
          requestCreateCallBack={() => {}}
          handlePointsRedeemLess={() => {}}
          id={0}
          isPoints={userPoints.userPointsRedeem.isPoints}
          type={1}
          is_new={true}
          isDetail={false}
        />
        {/* 次数不够 */}
        <EnoughQuotaModal type={'sourcing'} handleSubmit={handleSubmit} planShow={planShow} sourcingLimitModal={sourcingLimitModal} userPoints={userPoints} subList={subList} setSourcingLimitModal={setSourcingLimitModal}/>
        {/* 会员上限且积分不够 */}
        <EnoughPointsModal type={'sourcing'} open={enoughPoint} setOpen={setEnoughPoint}/>
        {/* 引导视频 */}
        <NoviceSourcingModal upgradeOpen={noviceModal} setUpgradeOpen={()=>setNoviceModal(false)}/>
        
      </Box>
    </Box>

    {loading && <SearchLoading />}
    </div>
  );
};

const useScreenWidth = () => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return width;
};


export default withRouter(SourcingRequestBox);
